import { Middleware, MiddlewareNext } from '@/router/middlewares/types';
import { Route } from 'vue-router';
import { HTTPServiceClient } from '@/packages/http/service';
import { VALIDATE_ENTITY_ACCESS_FOR_ORG } from '../../endpoints';
import { RootStore } from '../../store/index';
import { SET_VALIDATING_ENTITY_ACCESS } from '../../store/mutationTypes';

export const AuthEntityAccessForOrgMiddleware: Middleware = {
  async handle(
    to: Route,
    from: Route,
    next: MiddlewareNext,
    targetEntity: string
  ) {
    const orgId = to?.params?.organisationId;

    RootStore.commit(SET_VALIDATING_ENTITY_ACCESS, true);

    const orgCanAccessEntity = await HTTPServiceClient.get(
      VALIDATE_ENTITY_ACCESS_FOR_ORG(orgId, targetEntity)
    );

    RootStore.commit(SET_VALIDATING_ENTITY_ACCESS, false);

    if (!orgCanAccessEntity) {
      return next({
        name: 'dashboard'
      });
    }
  }
};
